/**
 * "Getting started" documentation section (ADR-0074).
 *
 * The hands-on path, in the order a customer actually takes it: the Quickstart
 * spine (embed → let it read → review → live), then the discovery page that
 * explains what "let it read" means and what it does and does not look at.
 *
 * `DISCOVERY_PAGE` is second rather than folded into the Quickstart because the
 * two answer different questions — "what do I do" and "what is it doing" — and
 * the second one is the one a security reviewer opens.
 */
import { DISCOVERY_PAGE } from './pages/discovery.page';
import { QUICKSTART_PAGE } from './pages/quickstart.page';

import type { DocSection } from './types';

export const GETTING_STARTED_SECTION: DocSection = {
  id: 'getting-started',
  titleKey: 'docs.section.gettingStarted.title',
  pages: [QUICKSTART_PAGE, DISCOVERY_PAGE],
};
